'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  extractData: function extractData(key) {
    return function extractData(data) {
      var extractedData = data[key];
      if (!extractedData) {
        throw new Error('Data could not be found with key `' + key + '`');
      }
      return extractedData;
    };
  },
  deserializeResourceList: function deserializeResourceList(deserializer) {
    return function deserializeResourceList(data) {
      if (data.length === undefined) {
        throw new Error('Data could not be deserialized, expected array.');
      }
      return data.map(deserializer);
    };
  }
};